import moment from 'moment';

export const isValidDate = (d) => d.toString().toLowerCase() !== 'invalid date';

export type DateData = {
  attrDate: string; // used for <time datetime="" />
  dateObj: Date;
  visualDate: string;
};

export default (value = null, options = null, dateFormat = 'YYYYMMDDTHHmmss', strictMode = true): DateData => {
  try {
    if (value === null) {
      return null;
    }

    // handle utc
    const date = (options?.isUTC) ?
      moment.utc(value, dateFormat, false) :
      moment.parseZone(value, dateFormat, strictMode);

    if (!date.isValid()) {
      return null;
    }

    // 01/09/2021
    if (options?.short) {
      return {
        attrDate: date.format('YYYY-MM-DD'),
        dateObj: date.toDate(),
        visualDate: date.format('DD/MM/YYYY')
      };
    }

    // 1 Sep 2021
    if (options?.medium) {
      return {
        attrDate: date.format('YYYY-MM-DD'),
        dateObj: date.toDate(),
        visualDate: date.format('D MMM Y')
      };
    }

    // output preferred format
    if (options?.outputFormat) {
      return {
        attrDate: date.format('YYYY-MM-DD'),
        dateObj: date.toDate(),
        visualDate: date.format(options.outputFormat)
      };
    }

    return {
      attrDate: date.format('YYYY-MM-DD'),
      dateObj: date.toDate(),
      visualDate: date.format('D MMMM YYYY')
    };
  } catch {
    return null;
  }
};

export const parseDateInfo = (dateString?: string) => {
  if (!dateString) return null;
  let d = new Date(dateString);
  if (isNaN(d.getTime())) {
    if (dateString.length >= 8 && /^\d{8}/.test(dateString)) {
      const year = dateString.substring(0, 4);
      const month = dateString.substring(4, 6);
      const day = dateString.substring(6, 8);
      // Build a local-time date so the calendar fields below read back unchanged.
      d = new Date(Number(year), Number(month) - 1, Number(day));
    } else {
      return null;
    }
  }
  return {
    day: d.getDate(),
    month: d.toLocaleString('en-US', { month: 'short' }).toUpperCase(),
    year: d.getFullYear()
  };
};